import React from "react";

import { Flex } from "../flex";
import { FlexItem } from "../flex-item";
import { Container, Description, InputArea, Label } from "./styled";
import type { SettingWrapperProps } from "./types";

export const SettingWrapper: React.FC<SettingWrapperProps> = ({
  label,
  description,
  children,
  className,
  testId,
  styleProps,
  disabled = false,
  htmlId,
}) => {
  // Generate a unique ID if not provided
  const uniqueId =
    htmlId || `setting-${label.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <Container
      className={className}
      data-testid={testId}
      $styleProps={styleProps}
      $disabled={disabled}
    >
      <Flex gap="20px">
        <FlexItem flex="0 0 210px">
          <Label
            htmlFor={uniqueId}
            $styleProps={styleProps}
            $disabled={disabled}
          >
            {label}
          </Label>
        </FlexItem>
        <FlexItem flex="1 1 auto">
          <InputArea $styleProps={styleProps} $disabled={disabled}>
            {/* Clone children and pass the unique ID if they support it */}
            {React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                // If the child has an id prop, use our generated ID
                // This helps with accessibility and label association
                return React.cloneElement(child, {
                  id: uniqueId,
                  disabled: disabled || child.props.disabled,
                  ...child.props,
                });
              }
              return child;
            })}
          </InputArea>
          {description && (
            <Description $styleProps={styleProps} $disabled={disabled}>
              {description}
            </Description>
          )}
        </FlexItem>
      </Flex>
    </Container>
  );
};
